module.exports = __webpack_public_path__ + "7f73a8f495aad74b65374681e70bdeee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/natixis_funds.png
// module id = 1704
// module chunks = 0